import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["blockIP", "unblockIP"]
  static values = { ip: String }

  connect() {
    fetch(`/admin/firewall/ban/${this.ipValue}`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then((response) => response.json())
      .then((response) => {
        $(this.element).children(".loader").hide()

        if (response.access_rule) {
          $(this.unblockIPTarget).removeClass("hidden")

          if (response.notes !== null && response.notes !== "") {
            const options = {
              content: response.notes,
              trigger: "hover",
              width: "300px",
            }
            $(this.unblockIPTarget).webuiPopover(options)
          }
        } else {
          $(this.blockIPTarget).removeClass("hidden")
        }
      })
  }
}
